// const AuditSystem = () => import(
//   /* webpackChunkName: "AuditSystem" */
//   './AuditSystem');
// const AuditEnterprise = () => import(
//   /* webpackChunkName: "AuditEnterprise" */
//   './AuditEnterprise');
const AuditRobot = () => import(
  /* webpackChunkName: "AuditRobot" */
  './AuditRobot');

export default {
  pages: [
    // {
    //   path: 'audit-system',
    //   name: 'audit-system',
    //   component: AuditSystem,
    // },
    // {
    //   path: 'audit-enterprise',
    //   name: 'audit-enterprise',
    //   component: AuditEnterprise,
    // },
    {
      path: 'audit-robot',
      name: 'audit-robot',
      component: AuditRobot,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/manage-modules/AuditLog/index.js